<template>
  <div class="building-info-row">
    <div class="building-info-left-img" v-if="showIndex%2 === 0">
      <img :src="info.img" />
    </div>
    <div class="building-info-center-content">
      <div class="title">{{info.name}}</div>
      <div class="vice-title">可用面积</div>
      <pre class="acreage">{{info.minAcreage}}m²<span v-if="info.maxAcreage">  -  {{info.maxAcreage}}m²</span></pre>
      <div class="synopsis">
        <span class="location" @click="goMap">【{{info.location}}】</span>
        <span class="info">{{info.synopsis}}</span>
      </div>
      <div class="img-list-row">
        <div class="left" @click="changePage(-1)">
           <img src="@/assets/images/gateway/icon-left.png" />
        </div>
        <div class="img-list">
          <!-- 原展示配套图 -->
          <!-- <div class="img-list-col"
          v-for="(item, index) in getImageList"
          :key="`${showIndex}${index}imgList`"
          >
            <el-image
              style="width: 100%; height: 100%"
              :src="item.src"
              :preview-src-list="item.srcList"
            />
            <div class="img-title">{{item.title}}</div>
          </div> -->
          <!-- 现图片平铺展示 -->
          <el-image
          v-for="(item, index) in getImageList"
          :key="`${showIndex}${index}imgList`"
          :src="item"
          class="img-list-col"
          :preview-src-list="getImageListAll"
          />
        </div>
        <div class="right" @click="changePage(1)">
          <img src="@/assets/images/gateway/icon-right.png" />
        </div>
      </div>
    </div>
    <div class="building-info-right-img" v-if="showIndex%2 !== 0">
      <img :src="info.img" />
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      showPage: 1
    }
  },
  computed: {
    getImageList () {
      return this.getImageListAll.slice((this.showPage - 1) * 3, this.showPage * 3)
    },
    getImageListAll () {
      let imaList = (this.info?.imgList || []).map((item) => {
        return [...item.srcList]
      })
      return (imaList || []).flat().map((item) => {
        return require(`@/assets/images/gateway/park/${item}.jpg`)
      })
    }
  },
  methods: {
    changePage (val) {
      let imaList = this.getImageListAll || []
      if (imaList.length < 3) return
      let showPage = this.showPage + val
      if (showPage > Math.ceil(imaList.length / 3)) {
        showPage = 1
      } else if (showPage < 1) {
        showPage = Math.ceil(imaList.length / 3)
      }
      this.showPage = showPage
    },
    goMap() {
      window.open(` http://api.map.baidu.com/marker?location=${this.info.coordinate}&title=${this.info.name}&content=${this.info.location}&output=html`)
    }
  },
  props: {
    info: {
      type: Object,
      default: () => {}
    },
    showIndex: {
      type: Number,
      default: 0
    }
  }
}
</script>

<style lang="scss" scoped>
.building-info-row {
  margin-bottom: 1rem;
  display: flex;
  justify-content: center;
  .building-info-left-img {
    width: 5rem;
    height: 4.5rem;
    margin-right: 1rem;
    box-shadow: -0.3rem -0.3rem 0 rgba($color: #3574bd, $alpha: 0.12);
    img {
      width: 100%;
      height: 100%;
    }
  }
  .building-info-right-img {
    width: 5rem;
    height: 4.5rem;
    margin-left: 1rem;
    box-shadow: 0.3rem -0.3rem 0 rgba($color: #3574bd, $alpha: 0.12);
    img {
      width: 100%;
      height: 100%;
    }
  }
  .building-info-center-content {
    width: 6rem;
    .title {
      font-size: 0.25rem;
      color: #333333;
      font-weight: bold;
      line-height: 0.5rem;
      position: relative;
      margin-bottom: 0.35rem;
      &::after {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 0.5rem;
        height: 0.05rem;
        border-radius: 0.02rem;
        background: #333;
        content: "";
      }
    }
    .vice-title {
      color: #666666;
      font-size: 0.12rem;
    }
    .acreage {
      color: #e59100;
      font-weight: bold;
      font-size: 0.18rem;
      line-height: 0.3rem;
    }
    .synopsis {
      display: flex;
      line-height: 0.4rem;
      // min-height: 1.2rem;
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
      overflow: hidden;
      text-overflow: ellipsis;
      .location {
        cursor: pointer;
        display: inline-block;
        color: #004ca4;
        white-space: nowrap;
        font-size: 0.14rem;
      }
      .info {
        color: #666666;
      }
    }
    .img-list-row {
      margin-top: 0.3rem;
      height: 1.5rem;
      background: rgba($color: #3574bd, $alpha: 0.12);
      padding: 0.22rem;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: space-evenly;
      .img-list {
        display: flex;
        width: 85%;
        height: 100%;
        // overflow: scroll;
        &::-webkit-scrollbar {
          display: none;
        }
        .img-list-col {
          position: relative;
          min-width: 30%;
          margin-right: 5%;
          .img-title {
            position: absolute;
            left: 0;
            bottom: 0;
            right: 0;
            background: rgba($color: #000, $alpha: 0.4);
            border-radius: 0 0 0.06rem 0.06rem;
            font-size: 0.14rem;
            line-height: 0.3rem;
            text-align: center;
            color: #fff;
          }
        }
        :last-child {
          margin-right: 0%;
        }
      }
      .left,
      .right {
        img {
          width: 0.2rem;
        }
      }
    }
  }
}
</style>